import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Manifesto } from './components/Manifesto';
import { Origin } from './components/Origin';
import { Rules } from './components/Rules';
import { Science } from './components/Science';
import { HonestLine } from './components/HonestLine';
import { Cta } from './components/Cta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Manifesto data-id="element-4" />
        <Origin data-id="element-5" />
        <Rules data-id="element-6" />
        <Science data-id="element-7" />
        <HonestLine data-id="element-8" />
        <Cta data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}